<template>
  <div>
    <el-dialog :title="action === 'editAgent' ? $t('text.editAgent') : $t('text.addAgent')" :visible.sync="dialogShow"
               @close="closeDialog" @open="openDialog"
               width="700px">

      <el-tabs @tab-click="handleSelect" v-model="activeIndex" style="margin-top: 25px">
        <el-tab-pane :label="$t('text.agentRateSetup')" value="agentRateSetup" name="agentRateSetup"></el-tab-pane>
        <el-tab-pane :label="$t('text.merchantOwnership')" value="merchantOwnership" name="merchantOwnership"></el-tab-pane>
      </el-tabs>

      <el-form :model="form" :rules="rules" ref="form">
        <div v-if="activeIndex === 'agentRateSetup'">
          <el-form-item :label="$t('text.agentName')" :label-width="formLabelWidth" prop="agentName">
            <el-input v-model="form.agentName" autocomplete="off" :placeholder="$t('message.inputAgentName')"/>
          </el-form-item>
          <el-form-item :label="$t('text.loginName')" :label-width="formLabelWidth" prop="loginName">
            <el-input v-model="form.loginName" autocomplete="off" :placeholder="$t('message.inputAgentLoginName')"
                      :disabled="action ==='editAgent'"/>
          </el-form-item>
          <el-form-item v-if="action ==='addAgent'" :label="$t('text.eMail')" :label-width="formLabelWidth" prop="email">
            <el-input v-model="form.email" autocomplete="off" :placeholder="$t('message.inputMail')"/>
          </el-form-item>

          <div style="display: flex; flex-direction: column;">
            <div
                v-for="(row, index) in mergedRows"
                :key="index"
                style="display: flex"
            >
              <div>
                <el-form-item
                    v-if="row.paymentKey"
                    :label="$t(`text.collection${row.paymentKey}FeeRate`)"
                    :label-width="formLabelWidth"
                    :prop="`paymentRateConfig.${row.paymentValue}`"
                >
                  <el-input
                      v-model="form.paymentRateConfig[row.paymentValue]"
                      :placeholder="$t('message.inputCollectionFeeRate')"
                      style="width: 150px"
                  />
                </el-form-item>
              </div>

              <div>
                <el-form-item
                    v-if="row.transferKey"
                    :label="$t(`text.disbursement${row.transferKey}FeeRate`)"
                    :label-width="formLabelWidth"
                    :prop="`transferRateConfig.${row.transferValue}`"
                >
                  <el-input
                      v-model="form.transferRateConfig[row.transferValue]"
                      :placeholder="$t('message.inputDisbursementFeeRate')"
                      style="width: 150px"
                  />
                </el-form-item>
              </div>
            </div>
          </div>
        </div>

        <div class="data-table" v-if="activeIndex === 'merchantOwnership'">
          <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 20px;">
            <el-form-item prop="appId" style="margin-bottom: 0;">
              <el-input
                  v-model="form.appId"
                  autocomplete="off"
                  :placeholder="$t('message.inputAppId')"
                  style="width: 500px"
              />
            </el-form-item>

            <el-button
                type="primary"
                @click="confirmCheck(form.appId,form.agentId,form.agentName)"
                :disabled="isAddButtonDisabled"
            >
              {{ $t('text.add') }}
            </el-button>
          </div>

          <el-table
              :data="this.form.merchantAgent"
              style="width: 100%">

            <el-table-column
                prop="merchantName"
                :label="$t('text.merchantName')"
                align="center"
                width="180">
            </el-table-column>

            <el-table-column
                prop="appId"
                :label="$t('text.appId')"
                align="center"
                width="180">
            </el-table-column>

            <el-table-column
                :label="$t('text.actions')"
                align="center"
                width="100">
              <template slot-scope="scope">
                <el-button
                    type="danger"
                    size="mini"
                    @click="confirmAgain(form.agentId,scope.row.appId,scope.row.merchantName)">
                  {{ $t('text.unbind') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer" v-if="activeIndex === 'agentRateSetup'">
        <el-button @click="closeDialog">{{ $t('text.cancel') }}</el-button>
        <el-button type="primary" @click="saveMerchant">{{ $t('text.confirm') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog title="确认" :visible.sync="checkDialogVisible">
      <p>
        确认将
        <span style="font-size: 16px; font-weight: bold;">{{ form.appId }}</span>
        归属到
        <span style="font-size: 16px; font-weight: bold;">{{ form.agentName }}</span> -
        <span style="font-size: 16px; font-weight: bold;">{{ form.agentId }}</span>
        代理吗?
      </p>

      <span slot="footer" class="dialog-footer">
        <el-button @click="checkDialogVisible = false">{{ $t('text.cancel') }}</el-button>
        <el-button type="primary" @click="createAgent(form.agentId,form.appId)"> {{ $t('text.add') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {PaymentType, getEmptyConfig} from '@/constants/paymentTypes';

export default {
  name: "SystemEdit",
  props: {
    show: Boolean,
    formData: Object,
    action: String,
  },

  // created() {
  //   this.$axios.get("/agent/selectListForOption", {params: {agentLevel: 1}}).then(res => {
  //     this.agentList = res.data;
  //   })
  // },
  data() {
    const generateRules = () => {
      const paymentConfig = PaymentType[this.$store.state.isPK ? 'PK' : 'BD'].PAYMENT;
      const transferConfig = PaymentType[this.$store.state.isPK ? 'PK' : 'BD'].TRANSFER;
      const rules = {
        agentName: [
          {required: true, message: this.$t('message.inputAgentName'), trigger: 'blur'},
          {min: 2, max: 20, message: this.$t('message.agentNameError'), trigger: 'blur'}
        ],
        loginName: [
          {required: true, message: this.$t('message.inputAgentLoginName'), trigger: 'blur'},
          {min: 6, max: 20, message: this.$t('message.loginNameLengthError'), trigger: 'blur'}
        ],
      };

      Object.keys(paymentConfig).forEach((value) => {
        rules[`paymentRateConfig.${paymentConfig[value]}`] = [
          {required: true, message: this.$t('message.inputCollectionFeeRate'), trigger: 'blur'},
          {pattern: /^\d+(\.\d{0,2})?$/, message: this.$t('message.numericError'), trigger: 'blur'}
        ];
      });
      Object.keys(transferConfig).forEach((value) => {
        rules[`transferRateConfig.${transferConfig[value]}`] = [
          {required: true, message: this.$t('message.inputDisbursementFeeRate'), trigger: 'blur'},
          {pattern: /^\d+(\.\d{0,2})?$/, message: this.$t('message.numericError'), trigger: 'blur'}
        ];
      });

      return rules;
    };

    return {
      dialogVisible: false,
      checkDialogVisible: false,
      dialogShow: this.show,
      country: this.$store.state.isPK ? 'PK' : 'BD',
      activeIndex: 'agentRateSetup',
      form: {
        loginName: "",
        merchantName: "",
        email: "test@gmail.com",
        depositStatus: "01",
        withdrawStatus: "01",
        prodStatus: "00",
        cashDeposit: 0,
        agentId: "",
        rcsIp: "127.0.0.1",
        freezeBalance: "0",
        withdrawalRate: "2",
        rechargeRate: "0",
        paymentRateConfig: getEmptyConfig(this.$store.state.isPK ? 'PK' : 'BD', 'PAYMENT'),
        transferRateConfig: getEmptyConfig(this.$store.state.isPK ? 'PK' : 'BD', 'TRANSFER'),
        productDetails: "",
        notifyV2: "01",
        settlementCycle: "D0",
        merchantType: "01",
        subMerchantName: "",
        subMerchantWebsiteURL: "",
        tgGroupIdCheck: 'false',
        tgGroupLanguage: '01',
        creditFlag: "00",
        creditRate: 0,
        merchantAgent: [],
        forceUpdate: false
      },
      // agentList: [],
      tableData: [],
      formLabelWidth: '180px',
      rules: generateRules()
    }
  },
  methods: {
    openDialog() {
      if (this.formData != null) {
        this.form.agentId = this.formData.agentId;
        this.form.agentName = this.formData.agentName;
        this.form.loginName = this.formData.loginName;
        this.form.logoUrl = this.formData.logoUrl;
        this.form.checkoutUrl = this.formData.checkoutUrl;
        this.form.merchantAgent = this.formData.merchantAgent;
        let paymentConfig = this.formData.paymentRateConfig ? this.formData.paymentRateConfig : '{}';
        paymentConfig = JSON.parse(paymentConfig);
        this.form.paymentRateConfig = {
          ...getEmptyConfig(this.country, 'PAYMENT'),
          ...paymentConfig
        };

        // transferRateConfig
        let transferConfig = this.formData.transferRateConfig ? this.formData.transferRateConfig : '{}';
        transferConfig = JSON.parse(transferConfig);
        this.form.transferRateConfig = {
          ...getEmptyConfig(this.country, 'TRANSFER'),
          ...transferConfig
        };
        this.form.forceUpdate = false;
      }
    },
    closeDialog() {
      // 先重置表单
      this.$refs["form"].clearValidate();

      // 然后手动设置默认值
      this.form = {
        agentId: '',
        agentName: '',
        loginName: '',
        email: 'test@gmail.com',
        logoUrl: '',
        checkoutUrl: '',
        // PK payment rates
        paymentJazzcashRate: '',
        paymentEasypaisaRate: '',
        paymentEasypaisaBillRate: '',
        paymentCardRate: '',
        transferJazzcashRate: '',
        transferEasypaisaRate: '',
        transferCardRate: '',
        // BD payment rates
        paymentRateConfig: getEmptyConfig(this.country, 'PAYMENT'),
        transferRateConfig: getEmptyConfig(this.country, 'TRANSFER')
      };
      this.activeIndex = 'agentRateSetup';

      this.$emit("update:show", false);
    },
    saveMerchant() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const paymentConfig = {
            ...getEmptyConfig(this.country, 'PAYMENT'),
            ...this.form.paymentRateConfig
          }
          const transferConfig = {
            ...getEmptyConfig(this.country, 'TRANSFER'),
            ...this.form.transferRateConfig
          };
          this.form.paymentRateConfig = JSON.stringify(paymentConfig);
          this.form.transferRateConfig = JSON.stringify(transferConfig);
          this.form.forceUpdate = false;

          if (this.action === 'editAgent') {
            this.axios.post("/agent/updateAgent", this.form).then(res => {
              if (res.code === 200) {
                this.$notify({
                  title: this.$t('message.editAgentSuccess'),
                  message: res.msg,
                  type: 'success'
                });

                this.$bus.$emit('refresh'); //通知刷新

                this.closeDialog();
              } else if ((res.msg || '').includes('通道成本')) {
                this.form.paymentRateConfig = JSON.parse(this.form.paymentRateConfig);
                this.form.transferRateConfig = JSON.parse(this.form.transferRateConfig);
                const warningMessage = (res.msg || '').replace(/；/g, '<br/>');
                this.$confirm(
                    `<div style="line-height: 1.6; margin-bottom: 12px;">${warningMessage}</div><div>${this.$t('message.confirmForceOperate')}</div>`,
                    this.$t('text.prompt'),
                    {
                      confirmButtonText: this.$t('text.confirm'),
                      cancelButtonText: this.$t('text.cancel'),
                      type: 'warning',
                      dangerouslyUseHTMLString: true,
                    })
                    .then(() => {
                      const paymentConfigForce = {
                        ...getEmptyConfig(this.country, 'PAYMENT'),
                        ...this.form.paymentRateConfig
                      };
                      const transferConfigForce = {
                        ...getEmptyConfig(this.country, 'TRANSFER'),
                        ...this.form.transferRateConfig
                      };
                      this.form.paymentRateConfig = JSON.stringify(paymentConfigForce);
                      this.form.transferRateConfig = JSON.stringify(transferConfigForce);
                      this.form.forceUpdate = true;
                      this.axios.post("/agent/updateAgent", this.form).then((forceRes) => {
                        if (forceRes.code === 200) {
                          this.$notify({
                            title: this.$t('message.editAgentSuccess'),
                            message: forceRes.msg,
                            type: 'success'
                          });
                          this.$bus.$emit('refresh');
                          this.closeDialog();
                        } else {
                          this.form.paymentRateConfig = JSON.parse(this.form.paymentRateConfig);
                          this.form.transferRateConfig = JSON.parse(this.form.transferRateConfig);
                          this.form.forceUpdate = false;
                          this.$notify.error({
                            title: this.$t('text.error'),
                            message: forceRes.msg,
                          });
                        }
                      });
                    })
                    .catch(() => {});
              } else {
                this.form.paymentRateConfig = JSON.parse(this.form.paymentRateConfig);
                this.form.transferRateConfig = JSON.parse(this.form.transferRateConfig);
                this.$notify.error({
                  title: this.$t('text.error'),
                  message: res.msg,
                });
              }
            })
          } else {
            this.axios.post("/agent/addAgent", this.form).then(res => {
              if (res.code === 200) {
                this.$notify({
                  title: this.$t('message.addAgentSuccess'),
                  message: res.msg,
                  type: 'success'
                });

                this.$bus.$emit('refresh'); //通知刷新

                this.closeDialog();
              } else {
                this.form.paymentRateConfig = JSON.parse(this.form.paymentRateConfig);
                this.form.transferRateConfig = JSON.parse(this.form.transferRateConfig);
                this.$notify.error({
                  title: this.$t('message.addAgentFailed'),
                  message: res.msg,
                });
              }
            })
          }
        } else {
          return false;
        }
      });
    },
    confirmCheck(appId, agentId, agentName) {
      const message = `
        确认将
        <span style="font-size: 16px; font-weight: bold;">${appId}</span>
        <br>
        归属到
        <span style="font-size: 16px; font-weight: bold;">${agentName}</span> -
        <span style="font-size: 16px; font-weight: bold;">${agentId}</span>
        代理吗?`;

      this.$confirm(`<div>${message}</div>`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.createAgent(agentId, appId)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
        });
      });
    },
    confirmAgain(agentId, appId, merchantName) {
      const message = `确定要解除商户 <span style="font-size: 16px; font-weight: bold;"> ${merchantName} - ${appId}</span> 绑定吗？`;

      this.$confirm(`<div>${message}</div>`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.deleteAgent(agentId, appId)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
        });
      });
    },
    deleteAgent(agentId, appId) {
      this.$refs.form.validate((valid) => {

        const param = {
          appId: appId,
          agentId: agentId,
        }

        this.$axios.put("/agent/delete-merchant-agent", param)
            .then(res => {
              if (res.code === 200) {
                this.$notify.success({
                  title: this.$t('text.prompt').toString(),
                  message: res.msg
                });
                this.merchantList = res.data
                this.dialogVisible = false;
                this.$bus.$emit('refresh');
                this.dialogShow = false;
                return true;
              } else {
                this.$notify.error({
                  title: this.$t('text.prompt').toString(),
                  message: res.msg
                });
                return false;
              }
            }).catch(() => {
          this.unlockPage();
        });
      });
    },
    createAgent(agentId, appId) {
      this.$refs.form.validate((valid) => {

        const param = {
          appId: appId,
          agentId: agentId,
        }

        this.$axios.post("/agent/create-merchant-agent", param)
            .then(res => {
              if (res.code === 200) {
                this.$notify.success({
                  title: this.$t('text.prompt').toString(),
                  message: res.msg
                });
                this.merchantList = res.data
                this.dialogVisible = false;
                this.$bus.$emit('refresh');
                this.dialogShow = false;
                return true;
              } else {
                this.$notify.error({
                  title: this.$t('text.error').toString(),
                  message: res.msg
                });
                return false;
              }
            }).catch((e) => {
          console.error(e);
        }).finally(() => {
          this.checkDialogVisible = false;
        });
      });
    },
    handleSelect(key) {
      this.activeIndex = key.name;
    },
  },
  watch: {
    show(newVal) {
      this.dialogShow = newVal;
    }
  },
  computed: {
    PaymentType() {
      return PaymentType
    },
    isAddButtonDisabled() {
      return !this.form.appId;
    },
    mergedRows() {
      const payments = PaymentType[this.country]?.PAYMENT || {};
      const transfers = PaymentType[this.country]?.TRANSFER || {};

      const allKeys = new Set([
        ...Object.keys(payments),
        ...Object.keys(transfers)
      ]);

      const result = [];

      allKeys.forEach((key) => {
        result.push({
          paymentKey: payments[key] ? key : null,
          paymentValue: payments[key] || null,
          transferKey: transfers[key] ? key : null,
          transferValue: transfers[key] || null
        });
      });

      return result;
    }
  },
}
</script>

<style scoped>

.data-table {
  padding-left: 50px;
}
</style>
